export default [
  {
    path: '/kanban',
    name: 'kanban',
    component: () => import('@/views/kanban/orders/index.vue'),
  },
]
